/* eslint-disable quotes */
/* eslint-disable object-curly-newline */
const listAdministratif = [
  {
    title: 'Finances',
    category: 'finance',
    listing: [
      {
        title: 'Assurances',
        img: 'house_insurance',
        form: [
          { label: 'Assureur', value: 'title', type: 'insurance' },
          { label: 'Type d\'assurance', placeholder: 'Prévoyance, responsabilité civile, protection juridique, assurance pour les locaux, etc', value: 'type', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Mutuelle',
        img: 'mutuelle',
        form: [
          { label: 'Nom de la mutuelle', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Prêts',
        img: 'loan',
        form: [
          { label: 'Organisme prêteur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Crédits',
        img: 'credit',
        form: [
          { label: 'Organisme créditeur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Caisse de retraite',
        img: 'retired',
        form: [
          { label: 'Nom de la caisse', value: 'title', type: 'input' },
          { label: 'Coordonnées de la caisse', value: 'address', type: 'input' },
          { label: 'Numéro de retraite ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
    ],
  },
  {
    title: 'Immobilier',
    category: 'housing',
    listing: [
      {
        title: 'Acte',
        img: 'deed',
        form: [
          { label: 'Propriété associée', value: 'title', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Bail',
        img: 'owner',
        form: [
          { label: 'Propriété associée', value: 'title', type: 'input' },
          { label: 'Coordonnées du propriétaire', value: 'address', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Syndic',
        img: 'trustee',
        form: [
          { label: 'Nom du syndic', value: 'title', type: 'input' },
          { label: 'Coordonnées', value: 'address', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Factures travaux',
        img: 'bill',
        form: [
          { label: 'Nom de la facture', value: 'title', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Charges',
        img: 'charges',
        form: [
          { label: 'Nom de la charge', value: 'title', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
    ],
  },
  {
    title: 'Abonnements',
    category: 'subscription',
    listing: [
      {
        title: 'Téléphonie',
        img: 'mobile',
        form: [
          { label: 'Opérateur', value: 'title', type: 'input' },
          { label: 'Numéro de téléphone', value: 'credential', type: 'input' },
          { label: 'Numéro de client', value: 'contract', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Internet',
        img: 'internet_box',
        form: [
          { label: 'Fournisseur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Énergie',
        img: 'energy',
        form: [
          { label: 'Fournisseur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Eau',
        img: 'water',
        form: [
          { label: 'Fournisseur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Logiciels',
        img: 'software',
        form: [
          { label: 'Nom de l\'abonnement', value: 'title', type: 'input' },
          { label: 'Numéro de client', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
    ],
  },
];

export const listAnnexesEstate = [
  {
    title: 'Contrats',
    category: 'housing',
    listing: [
      {
        title: 'Acte',
        img: 'deed',
        form: [
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Bail',
        img: 'owner',
        form: [
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Syndic',
        img: 'trustee',
        form: [
          { label: 'Nom du syndic', value: 'title', type: 'input' },
          { label: 'Coordonnées', value: 'address', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Factures travaux',
        img: 'bill',
        form: [
          { label: 'Nom de la facture', value: 'title', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Charges',
        img: 'charges',
        form: [
          { label: 'Nom de la charge', value: 'title', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
    ],
  },
  {
    title: 'Abonnements',
    category: 'subscription',
    listing: [
      {
        title: 'Téléphonie',
        img: 'mobile',
        form: [
          { label: 'Opérateur', value: 'title', type: 'input' },
          { label: 'Numéro de téléphone', value: 'credential', type: 'input' },
          { label: 'Numéro de client', value: 'contract', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Internet',
        img: 'internet_box',
        form: [
          { label: 'Fournisseur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Énergie',
        img: 'energy',
        form: [
          { label: 'Fournisseur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Eau',
        img: 'water',
        form: [
          { label: 'Fournisseur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
    ],
  },
  {
    title: 'Finances',
    category: 'finance',
    listing: [
      {
        title: 'Assurances',
        img: 'house_insurance',
        form: [
          { label: 'Assureur', value: 'title', type: 'insurance' },
          { label: 'Type d\'assurance', placeholder: 'Prévoyance, responsabilité civile, protection juridique, assurance pour les locaux, etc', value: 'type', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Prêts',
        img: 'loan',
        form: [
          { label: 'Organisme prêteur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
      {
        title: 'Crédits',
        img: 'credit',
        form: [
          { label: 'Organisme créditeur', value: 'title', type: 'input' },
          { label: 'Numéro de client ou de contrat', value: 'credential', type: 'input' },
          { label: 'Associer un scan, image ou PDF', value: 'documents', type: 'documents' },
          { label: 'Notes & instructions', value: 'notes', type: 'textarea' },
        ],
      },
    ],
  },
];

 export default listAdministratif;
